/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import { AbstractCase } from "../../../types/Entities/AbstractCase";
import { Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { Link } from "react-router";
import { getCaseLink } from "../../../services/productService";
import CalendlyAppointment from "../../Calendly/CalendlyAppointment";
import { STATUS_EXTRAJUDICIAL_COMMUNICATION_SENT } from "../../../services/litigationCase/leadStatus";
import ProductBox from "@/src/components/ProductBox/ProductBox";
import ProductBoxGrid from "@/src/components/ProductBoxGrid/ProductBoxGrid";

type CallBackPrototypeProps = {
  product: AbstractCase;
};

const MINIMUM_PRODUCT_ID = 9999999;
const ENABLED_INTERVAL = 800;

export default function CallBackPrototype({ product }: CallBackPrototypeProps) {
  const isEnabled =
    product.productCategory === "contractLaw" &&
    product.leadStatus >= STATUS_EXTRAJUDICIAL_COMMUNICATION_SENT &&
    product.caseCategory !== "advisory" &&
    product.isCustomerDataCompleted &&
    product.responsibleLawyer &&
    ["legalbird-dev", "eloise-neuhaus", "sonja-hartmann", "kristina-beyer"].some((substring) =>
      product.responsibleLawyer.calendlyCallbackLink.includes(substring),
    );

  if (!isEnabled) {
    return null;
  }

  if (import.meta.env.VITE_DEPLOYMENT === "production" && (product.id < MINIMUM_PRODUCT_ID || product.id > MINIMUM_PRODUCT_ID + ENABLED_INTERVAL)) {
    return null;
  }

  if (!product.callbackAppointment || product.callbackAppointment.status !== "created") {
    return (
      <ProductBox headline={"Rückruf buchen"}>
        <ProductBoxGrid
          items={[
            <Typography>
              Buchen Sie einen Rückruf mit Ihrem Anwalt, um offene Fragen zu klären. Wählen Sie einfach Ihren Wunschtermin, und Ihr Anwalt meldet sich bei
              Ihnen.
            </Typography>,
            <Button
              fullWidth
              variant={"contained"}
              color={"primary"}
              component={Link}
              to={`${getCaseLink(product)}${product.responsibleLawyer.calendlyCallbackLink}?utm_source=${encodeURIComponent(btoa("lbProductId=" + product.id))}`}
            >
              Rückruf buchen
            </Button>,
          ]}
        />
      </ProductBox>
    );
  }

  return <CalendlyAppointment product={product} customer={product.customer} type={"callbackAppointment"} />;
}
